import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  CalendarBox,
  CalendarIcon,
  CancelButton,
  ColSpan1,
  ColSpan2,
  ColSpan3,
  ColSpan4,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  Input,
  inputStyle,
  RelativeDiv,
  RowSpan,
  Span2,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import {useForm} from "react-hook-form";
import Select from "react-select";
import React, {useEffect, useState} from "react";
import {calculationAllType, exposureIntervalType, mediaResistInfo} from "./entity/common";
import {atom, useAtom} from "jotai";
import ko from "date-fns/locale/ko";
import {useLocation, useNavigate} from "react-router-dom";
import {
  bannerCategoryOneDepthListAll,
  bannerCategoryTwoDepthList, convertInventoryExamination,
  selInventory,
  targetingTypeList,
  updateInventory, uploadAudioFile
} from "../../services/mediamanage/InventoryAxios";
import {compareDate, dateFormat} from "../../common/StringUtils";
import {Textarea} from "./styles";
import {confirmAllType} from "./entity/medialistdetail";
import {defaultEnumerates} from "../../components/common/enumerate";
import styled, {css} from "styled-components";

import {toast, ToastContainer} from "react-toastify";
import {AudioEditor} from "../../components/common/AudioEditor";
import {tokenResultAtom} from "../login/entity";
import {DeleteUser} from "../../components/common/DeleteUser";
const mainColor = css`${props => props.theme.color.mainColor}`
const MediaInfoAtom = atom(mediaResistInfo)

function MediaListDetail(factory, deps) {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [mediaInfoState, setMediaInfoState] = useAtom(MediaInfoAtom);
  const [calculationAllTypeState] = useState(calculationAllType);
  const [examinationStatusState, setExaminationStatusState] = useState();
  const [feeCalculationState, setFeeCalculationState] = useState({
    id: '',
    calculationEtc: '',
    calculationType: '',
    calculationValue: 0,
    contractStartDate: new Date(new Date().setDate(new Date().getDate()+1))
  });
  const [tokenResultInfo, ] = useAtom(tokenResultAtom)
  const { formState: {errors}} = useForm()
  const [, setTargetingTypeState] = useState([])
  const [confirmAllTypeState] = useState(confirmAllType);
  const [exposureInterval] = useState(exposureIntervalType)
  const [mediaCategoryOneDepthState, setMediaCategoryOneDepthState] = useState([])
  const [, setMediaCategoryTwoDepthState] = useState([])
  const [showNonExposureConfigValue, setShowNonExposureConfigValue] = useState(true)
  const [file, setFile] = useState(null);
  const cloneDate = (d) => d ? new Date(d.getTime()) : null;
  const [validation, setValidation] = useState({
    targetingTypeMessage: '',
    calculationValueMessage:'정산 금액을 입력해주세요'
  })

  const {state} = useLocation();
  const navigate = useNavigate();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  const onDelete = () => {
    convertInventoryExamination(mediaInfoState.id, "DELETED")
    .then((response)=> {
        alert('지면이 삭제되었습니다.');
        navigate('/board/mediaList',{ state: {update:true}});
    });
  }
  const pickVideo = async () => {
    let returnVal = null;
    if (file.length !== 0) {
      await uploadAudioFile(file).then(response => {
        const { uploadedFile, path, duration } = response;
        if (uploadedFile) {
          toast.success('업로드에 성공 했습니다.');
          returnVal = {path: path, duration: duration};
        } else {
          toast.warning('업로드에 실패 했습니다.');
        }
      })
    }
    return returnVal;
  }
  const onSubmit = () => {
    if(mediaInfoState.feeCalculations.length === 0 ) {
      toast.warning('정산 정보를 입력해주세요.');
    } else if(mediaInfoState.nonExposureConfigType === 'FILE' && mediaInfoState.nonExposureConfigValue === ''){
        toast.warning('파일을 업로드 해주세요.');
    } else if (validation.targetingTypeMessage === '' && validation.targetingTypeMessage !==0) {
      console.log(file)
      if(mediaInfoState.nonExposureConfigType === 'FILE' && file != null) {
        pickVideo().then((response) => {
          if(response !== null){
            updateInventory(mediaInfoState.id,
                {...mediaInfoState,
                  examinationStatus: examinationStatusState,
                  inventoryType:mediaInfoState.inventoryType.value,
                  nonExposureConfigValue:response?.path,
                  nonExposureConfigDuration: response?.duration,
                  allowTargetings: mediaInfoState.allowTargetings.map(allowTargetings => {return {targetingType: allowTargetings.targetingType, exposureWeight: allowTargetings.exposureWeight}}),
                  exposureInterval: mediaInfoState.exposureInterval != null ? mediaInfoState.exposureInterval.value : null
                }
            ).then((response)=> {
              console.log(response)
              if(response != null){
                alert('지면 정보가 수정되었습니다.');
                navigate('/board/mediaList',{ state: {update:true}})
              }
            })
          }
        });
      } else {
        console.log(mediaInfoState)
        updateInventory(mediaInfoState.id,
            {...mediaInfoState,
              examinationStatus: examinationStatusState,
              inventoryType:mediaInfoState.inventoryType.value,
              allowTargetings: mediaInfoState.allowTargetings.map(allowTargetings => {return {targetingType: allowTargetings.targetingType, exposureWeight: allowTargetings.exposureWeight}}),
              exposureInterval: mediaInfoState.exposureInterval != null ? mediaInfoState.exposureInterval.value : null
            }
        ).then((response)=> {
          console.log(response)
          if(response != null){
            alert('지면 정보가 수정되었습니다.');
            navigate('/board/mediaList',{ state: {update:true}})
          }
        })
      }
    } else {
      if(validation.targetingTypeMessage === 0){
        setValidation({
          ...validation,
          calculationValueMessage: '정산 금액을 입력해주세요'
        })
      }
    }
    return null
  }

  useEffect(() => {
    if(state === null){
      navigate('/board/mediaList',{ state: {update:true}});
    } else {
      selInventory(state).then(response => {
        setMediaInfoState(response);
        setShowNonExposureConfigValue(response.nonExposureConfigType !== "DEFAULT_BANNER_IMAGE" && response.nonExposureConfigType !== "NONE");
        setExaminationStatusState(response.examinationStatus)
        bannerCategoryOneDepthListAll().then(response =>
            setMediaCategoryOneDepthState(response.values)
        )

      })
      targetingTypeList().then(response =>
          setTargetingTypeState(response.values)
      )
    }
  }, [navigate, setMediaInfoState, state])

  useEffect(()=>{
    let category1 = mediaCategoryOneDepthState.find(d=>d.value === mediaInfoState.category1);
    if(category1 !== '' && category1 !== undefined) {
      bannerCategoryTwoDepthList(category1).then(response=>
        setMediaCategoryTwoDepthState(response.values)
      )
    }
  },[mediaCategoryOneDepthState, mediaInfoState.category1])
  /**
   * 지면 상세 설명
   * @param event
   */
  const handleDescription = (event) => {
    setMediaInfoState({
      ...mediaInfoState,
      description: event.target.value
    })
  }
  const handleExposeMinuteLimit = (exposureInterval) => {
    setMediaInfoState({
      ...mediaInfoState,
      exposureInterval: exposureInterval.value
    })
  }
  const parseLocalDate = (d) => {
    if (!d) return null;

    // contractStartDate가 Date 객체면 그대로
    if (d instanceof Date) return d;

    // 문자열이면 로컬 00:00으로 강제 (UTC 파싱으로 하루 밀리는 이슈 방지)
    return new Date(`${d}`.replace(' ', 'T').substring(0, 10) + 'T00:00:00');
  };
  const getRangedFeeCalculations = () => {
    const list = mediaInfoState?.feeCalculations ?? [];

    const sortedAsc = [...list].sort((a, b) => {
      const aTime = parseLocalDate(a.contractStartDate)?.getTime() ?? 0;
      const bTime = parseLocalDate(b.contractStartDate)?.getTime() ?? 0;
      return aTime - bTime;
    });

    const rangedAsc = sortedAsc.map((item, idx) => {
      const start = cloneDate(parseLocalDate(item.contractStartDate));

      let end = null;
      if (idx < sortedAsc.length - 1) {
        end = cloneDate(parseLocalDate(sortedAsc[idx + 1].contractStartDate));
        if (end) end.setDate(end.getDate() - 1);
      }

      return {
        ...item,
        _rangeStart: start,
        _rangeEnd: end
      };
    });

    return rangedAsc.reverse();
  };

  const rangedFeeCalculations = getRangedFeeCalculations();

  /**
   * 심사여부 설정
   */
  const handleSelectConfirmType = (examinationStatus) => {
    setExaminationStatusState(examinationStatus.value)
  }
  /**
   * 정산방식 선택날짜
   * @param date
   */
  const handleContractDate = (date) => {
    if(compareDate(new Date(), new Date(date))) {
      setFeeCalculationState({
        ...feeCalculationState,
        contractStartDate: date
      })
    }
  }

  /**
   * 정산방식 선택
   * @param calculationType
   */
  const handleCalculationType = (calculationType) => {
    setFeeCalculationState({
      ...feeCalculationState,
      calculationType: calculationType.value
    })
  }

  /**
   * 정산방식 값 입력
   * @param calculationValue
   */
  const handleCalculationValue = (event) => {
    setValidation({
      ...validation,
      calculationValueMessage: ''
    })
    setFeeCalculationState({
      ...feeCalculationState,
      calculationValue: parseInt(event.target.value)
    })
  }
  // /**
  //  * 정산방식 값 입력
  //  * @param calculationValue
  //  */
  // const handleArrCalculationValue = (event, index) => {
  //   setMediaInfoState({
  //     ...mediaInfoState,
  //     feeCalculations: mediaInfoState.feeCalculations.map((e, i) => {
  //       return (i == index) ? {...e,  calculationValue: parseInt(event.target.value)} : e
  //     })
  //   })
  // }
  /**
   * 비고 입력
   * @param event
   */
  const handleCalculationEtc = (event) => {
    setFeeCalculationState({
      ...feeCalculationState,
      calculationEtc: event.target.value
    })
  }

  const addFeeCalculation = () => {
    if(mediaInfoState.feeCalculations.some(data => dateFormat(data.contractStartDate,'YYYYMMDD') === dateFormat(feeCalculationState.contractStartDate,'YYYYMMDD') )) {
      alert('같은 날짜를 추가할수 없습니다.')
    } else if(feeCalculationState.calculationType === ''){
      alert('정산 유형을 선택 해주세요.')
    } else if(feeCalculationState.calculationValue === 0){
      alert('정산 금액을 입력 해주세요.')
    } else {
      setMediaInfoState({
        ...mediaInfoState,
        feeCalculations: mediaInfoState.feeCalculations.concat({
          ...feeCalculationState,
          contractStartDate: new Date(feeCalculationState.contractStartDate)
        })
      });

      setFeeCalculationState({
        id: '',
        calculationEtc: '',
        calculationType: '',
        calculationValue: 0,
        contractStartDate: new Date(new Date().setDate(new Date().getDate()+1)),
      })
    }
  }
  const removeFeeCalculation = (data, e) => {
    e?.preventDefault?.()

    const key = dateFormat(data.contractStartDate, 'YYYYMMDD')

    setMediaInfoState({
      ...mediaInfoState,
      feeCalculations: mediaInfoState.feeCalculations.filter(item =>
          dateFormat(item.contractStartDate, 'YYYYMMDD') !== key
      )
    })
  }
  function handlePlaceholder (type) {
    switch (type){
      case 'CPM' : case 'CPC' : return '단위별 금액을 입력해주세요.';
      case 'RS' : return '정산 비율을 입력해주세요.';
      case 'GT' : return '개런티 비용을 입력해주세요.';
      default : return '단위별 금액을 입력해주세요.';
    }
  }

  /**
   * 미송출시 타입 선택
   * @param nonExposureConfigType
   */
  const handleNonExposureConfigType = (nonExposureConfigType) => {
    if (nonExposureConfigType === "DEFAULT_BANNER_IMAGE" || nonExposureConfigType === "NONE") {
      setShowNonExposureConfigValue(false)
    } else {
      setShowNonExposureConfigValue(true)
    }
    setMediaInfoState({
      ...mediaInfoState,
      nonExposureConfigType: nonExposureConfigType
    })
  }

  /**
   * 미송출시 데이터 입력
   * @param event
   */
  const handleNonExposureConfigValue = (event) => {
    setMediaInfoState({
      ...mediaInfoState,
      nonExposureConfigValue: event.target.value
    })
  }

  return (
    <DetailFormPage>
      <DetailHero>
        <HeroText>
          <HeroEyebrow>INVENTORY DETAIL</HeroEyebrow>
          <HeroTitle>지면 정보를 확인하고 수정해 주세요.</HeroTitle>
          <HeroDescription>지면 기본 정보부터 광고 상품·정산 정보까지 한 화면에서 관리합니다.</HeroDescription>
        </HeroText>
        <HeroMetrics>
          <HeroMetric $control>
            <span>심사 상태</span>
            <Select options={confirmAllTypeState}
                    styles={inputStyle}
                    isDisabled={mediaInfoState.examinationStatus !== 'CONFIRMING'}
                    isSearchable={false}
                    value={confirmAllType.find(data => data.value === examinationStatusState) || ""}
                    onChange={handleSelectConfirmType}
                    menuPortalTarget={document.body}
            />
          </HeroMetric>
          <HeroMetric><span>매체명</span><strong title={mediaInfoState.siteName}>{mediaInfoState.siteName || "-"}</strong></HeroMetric>
          <HeroMetric><span>지면명</span><strong title={mediaInfoState.inventoryName}>{mediaInfoState.inventoryName || "-"}</strong></HeroMetric>
          <HeroMetric><span>광고 상품</span><strong>{defaultEnumerates.productTypeInfo[mediaInfoState.productType] || "-"}</strong></HeroMetric>
        </HeroMetrics>
      </DetailHero>
      <DetailFormGrid>
      {/*지면 정보*/}
      <Board className="info-card">
        <BoardHeader>
          <CardHeaderTitle>지면 정보</CardHeaderTitle>
          <CardHeaderDescription>지면의 기본 정보를 확인하고 심사 상태를 관리합니다.</CardHeaderDescription>
        </BoardHeader>
        <BoardSearchDetail>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>매체명</Span2></ColTitle>
              <div>
                <Input type={'text'}
                       value={mediaInfoState.siteName || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>지면명</Span2></ColTitle>
              <div>
                <Input type={'text'}
                       value={mediaInfoState.inventoryName || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <RowSpan style={{marginTop: 0}}>
                <ColTitle><Span2>지면 카테고리</Span2></ColTitle>
                {/*<ColSpan2>*/}
                  <Input type={'text'}
                         value={mediaCategoryOneDepthState?.find(d=>d.value === mediaInfoState.category1)?.label || ""}
                         readOnly={true}
                  />
                {/*</ColSpan2>*/}
                {/*<ColSpan2>*/}
                {/*  <Input type={'text'}*/}
                {/*         value={mediaCategoryTwoDepthState?.find(d=>d.value === mediaInfoState.category2)?.label || ""}*/}
                {/*         readOnly={true}*/}
                {/*  />*/}
                {/*</ColSpan2>*/}
              </RowSpan>
            </ColSpan2>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>디바이스</Span2></ColTitle>
              <div>
                <Input type={'text'}
                       value={defaultEnumerates.deviceTypeInfo[mediaInfoState.deviceType] || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          {/*<RowSpan>*/}
          {/*  <ColSpan2>*/}
          {/*    <ColTitle><Span2>에이전트</Span2></ColTitle>*/}
          {/*    <div>*/}
          {/*      <Input type={'text'}*/}
          {/*             value={mediaInfoState.agentTypes.map(item => defaultEnumerates.agentTypeInfo[item]).join(', ')}*/}
          {/*             readOnly={true}*/}
          {/*      />*/}
          {/*    </div>*/}
          {/*  </ColSpan2>*/}
          {/*</RowSpan>*/}
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>URL</Span2><br/><small>(app market url)</small></ColTitle>
              <div>
                <Input type={'text'}
                       value={mediaInfoState.mediaUrl || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>지면 상세 설명</Span2><p>(선택입력)</p></ColTitle>
              <RelativeDiv>
                <Textarea rows={5}
                          maxLength={1000}
                          placeholder={''}
                          disabled={mediaInfoState.examinationStatus === "REJECTED"}
                          value={mediaInfoState.description || ''}
                          onChange={(e) => handleDescription(e)}

                />
                {errors.description && <ValidationScript>{errors.description?.message}</ValidationScript>}
              </RelativeDiv>
            </ColSpan2>
          </RowSpan>
        </BoardSearchDetail>
      </Board>
      {/*광고 상품 정보*/}
      <Board className="product-card">
        <BoardHeader>
          <CardHeaderTitle>광고 상품 정보</CardHeaderTitle>
          <CardHeaderDescription>등록된 광고 상품과 지면 유형을 확인합니다.</CardHeaderDescription>
        </BoardHeader>
        <BoardSearchDetail>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>광고 상품</Span2></ColTitle>
              <div>
                <Input type={'text'}
                       value={defaultEnumerates.productTypeInfo[mediaInfoState.productType] || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          <RowSpan>
            <ColSpan2>
              <ColTitle><Span2>지면 유형</Span2></ColTitle>
              <div>
                <Input type={'text'}
                       value={defaultEnumerates.inventoryTypeInfo[mediaInfoState.inventoryType] || ""}
                       readOnly={true}
                />
              </div>
            </ColSpan2>
          </RowSpan>
          {mediaInfoState.productType !== 'AUDIO' ? <>
            {mediaInfoState.productType !== 'POP_UNDER' ?
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span2>지면 사이즈</Span2></ColTitle>
                  <div>
                    <Input type={'text'}
                           value={defaultEnumerates.deleteIMG(mediaInfoState.bannerSize) || ""}
                           readOnly={true}
                    />
                  </div>
                </ColSpan2>
              </RowSpan>
                :
              <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span2>노출 간격</Span2></ColTitle>
                    <Select options={exposureInterval}
                            placeholder={'선택하세요'}
                            value={exposureInterval.find(type => type.value === mediaInfoState.exposureInterval) || ""}
                            isSearchable={false}
                            onChange={handleExposeMinuteLimit}
                            styles={inputStyle}
                            menuPortalTarget={document.body}
                    />
                  </ColSpan2>
                </RowSpan>
            }
          </> : <></>
          }

            {/* <RowSpan>
            <ColSpan3>
              <ColTitle><Span2>타겟팅 설정</Span2></ColTitle>
              <RelativeDiv>
                <EventSet>
                   <Checkbox label={'전체'}
                             type={'c'}
                             id={'ALL'}
                             disabled={mediaInfoState.examinationStatus === "REJECTED"}
                             isChecked={mediaInfoState.allowTargetings?.length === targetingTypeState?.length}
                             onChange={handleChangeSelectAll}/>
                  {
                    targetingTypeState.map((data, index)=>{
                      return <Checkbox label={data.label}
                                       key={index}
                                       type={'c'}
                                       disabled={mediaInfoState.examinationStatus === "REJECTED"}
                                       id={data.value}
                                       isChecked={mediaInfoState.allowTargetings.find(event => event?.targetingType === data.value) !== undefined}
                                       onChange={handleChangeChecked}/>
                    })
                  }
                </EventSet>
                {validation.targetingTypeMessage !== '' &&
                  <ValidationScript>{validation.targetingTypeMessage}</ValidationScript>}
              </RelativeDiv>
            </ColSpan3>
            <ColSpan1/>
          </RowSpan>
          <RowSpan>
            <ColSpan3>
              <ColTitle><Span2>타겟팅 가중치</Span2></ColTitle>
              <CostManageContainer>
                {targetingTypeState.map((targetingState, index) => {
                  return (
                    <div key={index}>
                      <Span2>{targetingState.label}</Span2>
                      <div>
                        <InputLabel label={'%'}>
                        <Input type={'number'}
                               maxLength={3}
                               placeholder={'-'}
                               id={targetingState.value}
                               disabled={mediaInfoState.allowTargetings.find(allowTargetings => allowTargetings.targetingType === targetingState.value) === undefined || mediaInfoState.examinationStatus === "REJECTED"}
                               value={mediaInfoState.allowTargetings.find(data => data.targetingType === targetingState.value) ? mediaInfoState.allowTargetings.find(allowTargetings => allowTargetings.targetingType === targetingState.value).exposureWeight: ''}
                               onChange={(e) => handleAllowTargetings(e)}
                               onInput={(e) => {
                                 if (e.target.value.length > e.target.maxLength)
                                   e.target.value = e.target.value.slice(0, e.target.maxLength);
                               }}
                        />
                        </InputLabel>
                      </div>
                    </div>
                  )
                })}
              </CostManageContainer>
            </ColSpan3>
          </RowSpan>
          */}
        </BoardSearchDetail>
      </Board>

        {/*매체 정산 정보*/}
        <Board className="account-card">
          <BoardHeader>
            <CardHeaderTitle>매체 정산 정보</CardHeaderTitle>
            <CardHeaderDescription>지면의 정산 방식과 계약 기간을 관리합니다.</CardHeaderDescription>
          </BoardHeader>
          <BoardSearchDetail>
            <AccountSection>
              <AccountSectionHeader>
                <strong>새 정산 방식 등록</strong>
                <span>계약 시작일을 기준으로 이후 적용될 정산 방식을 추가합니다.</span>
              </AccountSectionHeader>
              {mediaInfoState.examinationStatus !== "REJECTED" ? (
                <AccountAddForm>
                  <AccountField>
                    <AccountFieldLabel>시작 날짜</AccountFieldLabel>
                    <div style={{position: "relative"}}>
                      <DateContainer>
                        <CalendarBox>
                          <CalendarIcon/>
                        </CalendarBox>
                        <CustomDatePicker
                            showIcon={false}
                            selected={new Date(feeCalculationState.contractStartDate)}
                            minDate={tomorrow}
                            onChange={(date) => handleContractDate(date)}
                            locale={ko}
                            dateFormat="yyyy-MM-dd"
                            isClearable={false}
                            portalId="media-detail-datepicker-portal"
                        />
                      </DateContainer>
                    </div>
                  </AccountField>
                  <AccountField>
                    <AccountFieldLabel>정산 유형</AccountFieldLabel>
                    <Select options={calculationAllTypeState.filter((data,i) => i !== 0)}
                            placeholder={'선택하세요'}
                            styles={inputStyle}
                            value={calculationAllType.find(data => data.value === feeCalculationState.calculationType) || ''}
                            isSearchable={false}
                            onChange={handleCalculationType}
                            menuPortalTarget={document.body}
                    />
                  </AccountField>
                  <AccountField>
                    <AccountFieldLabel>정산 금액</AccountFieldLabel>
                    <Input type={'number'}
                           min={0}
                           style={{color:`${mainColor}`}}
                           placeholder={handlePlaceholder(feeCalculationState.calculationType)}
                           value={feeCalculationState.calculationValue || ''}
                           onChange={(e) => handleCalculationValue(e)}
                    />
                    {errors.calculationValue &&
                        <ValidationScript>{errors.calculationValue?.message}</ValidationScript>}
                  </AccountField>
                  <AccountField>
                    <AccountFieldLabel>비고</AccountFieldLabel>
                    <Input type={'text'}
                           placeholder={'비고 (선택)'}
                           value={feeCalculationState.calculationEtc != null ? feeCalculationState.calculationEtc : ''}
                           onChange={(e) => handleCalculationEtc(e)}
                    />
                  </AccountField>
                  <AccountField>
                    <AccountFieldLabel aria-hidden="true">&nbsp;</AccountFieldLabel>
                    <AccountAddButton type="button" onClick={() => addFeeCalculation()}>
                      <span>+</span>추가
                    </AccountAddButton>
                  </AccountField>
                </AccountAddForm>
              ) : (
                <AccountAddDisabled>심사 반려된 지면은 정산 방식을 추가할 수 없습니다.</AccountAddDisabled>
              )}
            </AccountSection>

            <AccountSection>
              <AccountSectionHeader>
                <strong>일자별 정산 방식</strong>
                <span>등록된 정산 방식을 계약 시작일 기준 최신순으로 확인합니다.</span>
              </AccountSectionHeader>
              {rangedFeeCalculations.length > 0 ? (
                <AccountTableScroll>
                  <AccountTable>
                    <AccountTableHead>
                      <span>적용 기간</span>
                      <span>정산 유형</span>
                      <span>정산 금액</span>
                      <span>비고</span>
                      <span/>
                    </AccountTableHead>
                    <div>
                      {rangedFeeCalculations.map((calculationData, index) => (
                        <AccountTableRow key={index}>
                          <span>
                            {calculationData._rangeEnd
                                ? `${dateFormat(calculationData._rangeStart, 'YYYY-MM-DD')} ~ ${dateFormat(calculationData._rangeEnd, 'YYYY-MM-DD')}`
                                : `${dateFormat(calculationData._rangeStart, 'YYYY-MM-DD')} ~`}
                          </span>
                          <span>{calculationAllType.find(data => data.value === calculationData.calculationType)?.label || calculationData.calculationType || '-'}</span>
                          <span>{calculationData.calculationValue != null ? Number(calculationData.calculationValue).toLocaleString('ko-KR') : '-'}</span>
                          <span>{calculationData.calculationEtc || '-'}</span>
                          <span>
                            {compareDate(new Date(), new Date(calculationData.contractStartDate)) &&
                              <AccountRemoveButton type="button" onClick={(e) => removeFeeCalculation(calculationData, e)} aria-label="정산 방식 삭제">×</AccountRemoveButton>
                            }
                          </span>
                        </AccountTableRow>
                      ))}
                    </div>
                  </AccountTable>
                </AccountTableScroll>
              ) : (
                <AccountEmpty>등록된 정산 방식이 없습니다.</AccountEmpty>
              )}
            </AccountSection>
          </BoardSearchDetail>
        </Board>

      {/*추가 정보 입력*/}
      <Board className="additional-card">
        <BoardHeader>
          <CardHeaderTitle>추가 정보 입력</CardHeaderTitle>
          <CardHeaderDescription>광고 미송출 시 대체 노출 방식을 설정합니다.</CardHeaderDescription>
        </BoardHeader>
        <BoardSearchDetail>
            <RowSpan>
              <ColSpan3>
                <ColTitle style={{marginRight: 10}}><Span4>광고 미송출 대체 설정</Span4></ColTitle>
                <ColSpan2>
                  <input type={'radio'}
                         id={'none'}
                         name={'substitute'}
                         disabled={mediaInfoState.examinationStatus === "REJECTED"}
                         checked={mediaInfoState.nonExposureConfigType === 'NONE'}
                         onChange={() => handleNonExposureConfigType('NONE')}
                  />
                  <label htmlFor={'none'}>없음</label>
                  {mediaInfoState.productType === 'BANNER' &&
                    <>
                      <input type={'radio'}
                             checked={mediaInfoState.nonExposureConfigType === 'DEFAULT_BANNER_IMAGE'}
                             id={'defaultImage'}
                             name={'substitute'}
                             disabled={mediaInfoState.examinationStatus === "REJECTED"}
                             onChange={() => handleNonExposureConfigType('DEFAULT_BANNER_IMAGE')}
                      />
                      <label htmlFor={'defaultImage'}>대체 이미지</label>
                    </>
                  }
                  <input type={'radio'}
                         checked={mediaInfoState.nonExposureConfigType === 'JSON'}
                         id={'jsonData'}
                         name={'substitute'}
                         disabled={mediaInfoState.examinationStatus === "REJECTED"}
                         onChange={() => handleNonExposureConfigType('JSON')}
                  />
                  <label htmlFor={'jsonData'}>JSON DATA</label>
                  <input type={'radio'}
                         checked={mediaInfoState.nonExposureConfigType === 'URL'}
                         id={'URL'}
                         name={'substitute'}
                         disabled={mediaInfoState.examinationStatus === "REJECTED"}
                         onChange={() => handleNonExposureConfigType('URL')}
                  />
                  <label htmlFor={'URL'}>URL</label>
                  <input type={'radio'}
                         checked={mediaInfoState.nonExposureConfigType === 'SCRIPT'}
                         id={'script'}
                         name={'substitute'}
                         disabled={mediaInfoState.examinationStatus === "REJECTED"}
                         onChange={() => handleNonExposureConfigType('SCRIPT')}
                  />
                  <label htmlFor={'script'}>script</label>
                  <input type={'radio'}
                         checked={mediaInfoState.nonExposureConfigType === 'FILE'}
                         id={'file'}
                         name={'substitute'}
                         disabled={mediaInfoState.examinationStatus === "REJECTED"}
                         onChange={() => handleNonExposureConfigType('FILE')}
                  />
                  <label htmlFor={'file'}>파일</label>
                </ColSpan2>
              </ColSpan3>
            </RowSpan>

            <RowSpan>
              <ColSpan4>
                <ColTitle><Span4></Span4></ColTitle>
                <RelativeDiv>
                  {showNonExposureConfigValue ?
                      (mediaInfoState.nonExposureConfigType === 'FILE' ?
                          <AudioEditor file={file} setFile={setFile} filePath={mediaInfoState.nonExposureConfigValue}/>
                          :
                          <Textarea rows={5}
                                    placeholder={'미송출시 대체 광고 정보를 입력하세요'}
                                    value={mediaInfoState.nonExposureConfigValue || ''}
                                    onChange={(e) => handleNonExposureConfigValue(e)}
                          />):''
                  }
                </RelativeDiv>
              </ColSpan4>
            </RowSpan>
          </BoardSearchDetail>
      </Board>
      { tokenResultInfo.role === 'SUPER_ADMIN' &&
          <Board className="delete-card">
            <DeleteToggle type="button" $open={isDeleteOpen} onClick={() => setIsDeleteOpen(open => !open)} aria-expanded={isDeleteOpen}>
              <div><strong>지면 삭제</strong><span>삭제한 지면은 복구할 수 없으므로 신중하게 진행해 주세요.</span></div>
              <DeleteArrow $open={isDeleteOpen}>⌄</DeleteArrow>
            </DeleteToggle>
            {isDeleteOpen && <BoardSearchDetail>
              <DeleteWarning>
                <DeleteWarningIcon aria-hidden="true">!</DeleteWarningIcon>
                <DeleteWarningContent>
                  <strong>삭제 후 복구할 수 없습니다.</strong>
                  <span>지면을 삭제하면 연결된 광고 송출 정보가 함께 영구 삭제됩니다. 삭제할 지면을 다시 확인해 주세요.</span>
                </DeleteWarningContent>
                <DeleteWarningAction>
                  <span>삭제할 지면 정보를 확인한 후 진행해 주세요.</span>
                  <DeleteUser title={"삭제하기"} onSubmit={onDelete} btnStyle={'SearchUser'}/>
                </DeleteWarningAction>
              </DeleteWarning>
            </BoardSearchDetail>}
          </Board>
      }
      </DetailFormGrid>
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
      <SubmitContainer>
        <ActionGuide>
          <strong>지면 정보 설정</strong>
          <span>변경한 정보를 확인한 뒤 수정 버튼을 눌러 저장해 주세요.</span>
        </ActionGuide>
        <ActionButtons>
          <CancelButton type={'button'} onClick={() => navigate('/board/mediaList')}>목록</CancelButton>
          {mediaInfoState.examinationStatus !== "REJECTED" &&
              <SubmitButton type={'submit'} onClick={onSubmit}>정보 수정</SubmitButton>
          }
        </ActionButtons>
      </SubmitContainer>
    </DetailFormPage>
  )
}

export default MediaListDetail

const DetailFormPage = styled.div`
  width: 100%;

  ${SubmitContainer} {
    position: sticky;
    bottom: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 16px 0 0;
    padding: 16px 20px;
    border: 1px solid var(--theme-primary-border);
    border-left: 4px solid var(--theme-primary);
    border-radius: 10px;
    background: var(--theme-primary-softest);
  }

  ${CancelButton},
  ${SubmitButton} {
    width: auto;
    min-width: 92px;
    height: 40px;
    margin: 0;
    padding: 0 18px;
    border-radius: 7px;
    font-size: 11px;
    font-weight: 700;
  }

  ${CancelButton} {
    border-color: #d8dfe6;
    background: #fff;
    color: #65717d;

    &:hover {
      border-color: #c7ccd2;
      background: #f5f6f8;
    }
  }

  ${SubmitButton} {
    border-color: var(--theme-primary-strong);
    background: var(--theme-primary-strong);
    color: #fff;

    &:hover {
      background: var(--theme-primary-hover);
    }
  }

  @media (max-width: 760px) {
    ${SubmitContainer} {
      align-items: stretch;
      flex-direction: column;
    }
  }
`;

const DetailHero = styled.section`
  position: relative;
  display: grid;
  grid-template-columns: minmax(240px, .8fr) minmax(0, 1.6fr);
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
  padding: 24px;
  border: 1px solid var(--theme-primary-border);
  border-radius: 12px;
  background: linear-gradient(135deg, var(--theme-primary-softest) 0%, #fff 62%);
  box-shadow: 0 7px 22px rgba(30, 58, 138, .055);

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: 12px 12px 0 0;
    background: var(--theme-primary);
    content: "";
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const HeroText = styled.div``;

const HeroEyebrow = styled.div`
  margin-bottom: 7px;
  color: var(--theme-primary);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .14em;
`;

const HeroTitle = styled.h2`
  margin: 0;
  color: #20242b;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: -.025em;
`;

const HeroDescription = styled.p`
  margin: 8px 0 0;
  color: #7f8994;
  font-size: 10px;
  line-height: 1.6;
`;

const HeroMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const HeroMetric = styled.div`
  min-width: 0;
  padding: 13px 14px;
  border: 1px solid #e3eaf2;
  border-radius: 9px;
  background: rgba(255, 255, 255, .92);

  span, strong {
    display: block;
  }

  span {
    margin-bottom: 6px;
    color: #8b95a0;
    font-size: 9px;
  }

  strong {
    overflow: hidden;
    color: #34404d;
    font-size: 11px;
    font-weight: 750;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${({$control}) => $control && css`
    padding: 9px 10px;

    [class*="-control"] {
      min-height: 30px !important;
      border-color: #dbe4ee !important;
      border-radius: 6px !important;
      background: #fff !important;
      box-shadow: none !important;

      &:hover {
        border-color: #93c5fd !important;
      }
    }

    [class*="-ValueContainer"] {
      padding: 0 8px !important;
    }

    [class*="-IndicatorsContainer"] svg {
      width: 15px;
      height: 15px;
    }

    [class*="-singleValue"],
    [class*="-placeholder"] {
      font-size: 10px !important;
      font-weight: 750;
    }
  `}
`;

const DetailFormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${Board} {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 1px solid #e5e8eb;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 5px 18px rgba(31, 41, 55, .045);
  }

  ${BoardHeader} {
    display: flex;
    min-height: 66px;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin: 0;
    padding: 0 20px;
    border-bottom: 1px solid #e5e8eb;
    background: linear-gradient(135deg, rgb(255, 255, 255) 0%, rgb(246, 250, 255) 100%)
  }

  ${BoardSearchDetail} {
    box-sizing: border-box;
    padding: 6px 20px 18px;
  }

  ${BoardSearchDetail} > ${RowSpan} {
    align-items: center;
    min-height: 54px;
    margin-top: 0;
    padding: 12px 0;
    border-bottom: 1px solid #edf0f3;
  }

  ${BoardSearchDetail} > ${RowSpan}:last-child {
    border-bottom: 0;
  }

  ${ColTitle} {
    color: #444;
    font-size: 11px;
    font-weight: 700;
  }

  ${Input},
  ${Textarea},
  select {
    border-color: #dfe3e7;
    border-radius: 8px;
    background-color: #fff;
    color: #333;
    font-size: 11px;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus {
      border-color: var(--theme-primary);
      outline: none;
      box-shadow: 0 0 0 3px var(--theme-primary-focus-ring);
    }
  }

  ${Input} {
    height: 42px;

    &[readonly] {
      background: #f5f7f9;
      color: #7c8794;
      cursor: default;
    }

    &:disabled {
      background: #f5f6f8;
      color: #b0b8c1;
      cursor: not-allowed;
    }
  }

  ${Textarea} {
    min-height: 92px;
    padding: 12px 14px;
    resize: vertical;

    &:disabled {
      background: #f5f6f8;
      color: #b0b8c1;
    }
  }

  input[type='radio'] {
    margin: 0 7px 0 0;
    border: 1px solid #b8c1cc;
    border-radius: 50%;
    background: #fff;
    background-image: none !important;
    box-shadow: none;
    cursor: pointer;
  }

  input[type='radio']:checked {
    border-color: var(--theme-primary);
    background: var(--theme-primary);
    background-image: none !important;
    box-shadow: inset 0 0 0 4px #fff;
  }

  input[type='radio']:disabled {
    opacity: .5;
    cursor: not-allowed;
  }

  input[type='radio'] + label {
    color: #56616d;
    font-size: 10px;
    cursor: pointer;
  }

  input[type='radio']:disabled + label {
    color: #b0b8c1;
    cursor: not-allowed;
  }

  [class*="-control"] {
    min-height: 42px !important;
    border-color: #dfe3e7 !important;
    border-radius: 8px !important;
    background: #fff !important;
    box-shadow: none !important;
    cursor: pointer;

    &:hover {
      border-color: var(--theme-primary-border) !important;
    }

    &:focus-within {
      border-color: var(--theme-primary) !important;
      box-shadow: 0 0 0 3px var(--theme-primary-focus-ring) !important;
    }
  }

  [class*="-ValueContainer"] {
    padding: 2px 11px !important;
    color: #46515d;
    font-size: 10px;
  }

  [class*="-placeholder"] {
    color: #9aa3ad !important;
    font-size: 10px;
  }

  [class*="-indicatorSeparator"] {
    display: none;
  }

  [class*="-indicatorContainer"] {
    padding: 7px !important;
    color: #89939e !important;
  }

  [class*="-menu"] {
    z-index: 20;
    overflow: hidden;
    border: 1px solid #dfe3e7;
    border-radius: 8px !important;
    box-shadow: 0 10px 24px rgba(31, 41, 55, .12) !important;
    font-size: 10px;
  }

  ${DateContainer} {
    height: 42px;
    border-color: #dfe5eb;
    border-radius: 8px;
    background: #fff;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus-within {
      border-color: var(--theme-primary);
      box-shadow: 0 0 0 3px var(--theme-primary-focus-ring);
    }

    ${CustomDatePicker} {
      height: 40px;
      border: 0;
      background: transparent;
      color: #46515d;
      font-size: 10px;
      outline: none;
    }
  }

  ${CalendarBox} {
    display: inline-flex;
    width: 40px;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #edf0f3;
    background: #f8fafc;
    color: #64748b;
  }

  ${CalendarIcon} {
    width: 15px;
    height: 16px;
    opacity: .8;
  }

  .react-datepicker {
    overflow: hidden;
    border: 1px solid #dfe3e7;
    border-radius: 10px;
    box-shadow: 0 12px 30px rgba(31, 41, 55, .14);
    font-family: inherit;
  }

  .react-datepicker__header {
    border-bottom-color: #edf0f3;
    background: #f8fafc;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: var(--theme-primary);
    color: #fff;
  }

  .react-datepicker__day:hover {
    background: var(--theme-primary-soft-hover);
    color: var(--theme-main);
  }

  ${ValidationScript} {
    color: #d14343;
    font-size: 9px !important;
  }

  @media (max-width: 820px) {
    ${RowSpan} {
      align-items: stretch;
      flex-direction: column;
      gap: 8px;
    }

    ${ColSpan1} {
      width: 100%;
      flex-wrap: wrap;
    }
  }
`;

const AccountSection = styled.div`
  & + & {
    margin-top: 22px;
    padding-top: 20px;
    border-top: 1px solid #edf0f3;
  }
`;

const AccountSectionHeader = styled.div`
  margin-bottom: 12px;

  strong {
    display: block;
    color: #2d3742;
    font-size: 12px;
    font-weight: 750;
  }

  span {
    display: block;
    margin-top: 3px;
    color: #8a949f;
    font-size: 10px;
  }
`;

const AccountAddForm = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)) 96px;
  align-items: start;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e3e8ee;
  border-radius: 8px;
  background: #f9fafb;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & > *:last-child {
      grid-column: 1 / -1;
    }
  }
`;

const AccountField = styled.div`
  position: relative;
  min-width: 0;
`;

const AccountFieldLabel = styled.span`
  display: block;
  margin-bottom: 6px;
  color: #67717d;
  font-size: 10px;
  font-weight: 700;
`;

const AccountAddButton = styled.button`
  display: inline-flex;
  width: 100%;
  height: 42px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 16px;
  border: 1px solid var(--theme-primary-strong);
  border-radius: 8px;
  background: var(--theme-primary-strong);
  color: #fff;
  font-size: 11px;
  font-weight: 750;
  white-space: nowrap;
  cursor: pointer;

  span {
    font-size: 14px;
  }

  &:hover {
    background: var(--theme-primary-hover);
  }
`;

const AccountAddDisabled = styled.div`
  padding: 14px;
  border: 1px dashed #dfe3e7;
  border-radius: 8px;
  background: #f9fafb;
  color: #9aa3ad;
  font-size: 10.5px;
  text-align: center;
`;

const AccountTableScroll = styled.div`
  overflow-x: auto;
`;

const AccountTable = styled.div`
  min-width: 640px;
  overflow: hidden;
  border: 1px solid #e5e9ee;
  border-radius: 8px;
`;

const ACCOUNT_TABLE_COLUMNS = 'minmax(170px, 1.3fr) minmax(90px, .8fr) minmax(100px, .9fr) minmax(0, 1.2fr) 36px';

const AccountTableHead = styled.div`
  display: grid;
  grid-template-columns: ${ACCOUNT_TABLE_COLUMNS};
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 2px solid #8bb8ea;
  background: #f2f7fd;

  span {
    color: #34475a;
    font-size: 10px;
    font-weight: 750;
  }
`;

const AccountTableRow = styled.div`
  display: grid;
  grid-template-columns: ${ACCOUNT_TABLE_COLUMNS};
  align-items: center;
  gap: 8px;
  padding: 11px 14px;
  border-bottom: 1px solid #edf1f4;
  background: #fff;

  &:last-child {
    border-bottom: 0;
  }

  span {
    overflow: hidden;
    color: #46515d;
    font-size: 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const AccountRemoveButton = styled.button`
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border: 1px solid #f3c9c9;
  border-radius: 6px;
  background: #fff5f5;
  color: #d9534f;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: #fee2e2;
  }
`;

const AccountEmpty = styled.div`
  padding: 22px;
  border: 1px dashed #e5e9ee;
  border-radius: 8px;
  color: #9aa3ad;
  font-size: 10.5px;
  text-align: center;
`;

const ActionGuide = styled.div`
  min-width: 0;
  text-align: left;

  strong, span {
    display: block;
  }

  strong {
    color: #2f3438;
    font-size: 12px;
    font-weight: 800;
  }

  span {
    margin-top: 4px;
    color: #7f878e;
    font-size: 9px;
    line-height: 1.45;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;

  @media (max-width: 760px) {
    width: 100%;

    button {
      flex: 1;
    }
  }
`;

const CardHeaderTitle = styled.strong`
  flex: 0 0 auto;
  color: #20242b;
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
`;

const CardHeaderDescription = styled.span`
  min-width: 0;
  overflow: hidden;
  color: #8a949f;
  font-size: 9px;
  font-weight: 500;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 640px) {
    white-space: normal;
  }
`;

const DeleteToggle = styled.button`
  display: flex;
  width: 100%;
  min-height: 66px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 20px;
  border: 0;
  border-bottom: ${({$open}) => ($open ? "1px solid #f2d5d5" : "1px solid transparent")};
  background: #fff;
  color: inherit;
  text-align: left;
  cursor: pointer;

  strong, span {
    display: block;
  }

  strong {
    color: #2f3438;
    font-size: 15px;
    font-weight: 700;
  }

  span {
    margin-top: 5px;
    color: #9a7b7b;
    font-size: 9px;
  }

  &:hover {
    background: #fffafa;
  }
`;

const DeleteArrow = styled.span`
  display: inline-flex;
  color: #d14343;
  font-size: 20px;
  transform: rotate(${({$open}) => ($open ? "180deg" : "0deg")});
  transition: transform .18s ease;
`;

const DeleteWarning = styled.div`
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) minmax(210px, .55fr);
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  padding: 18px;
  border: 1px solid #f2c2c2;
  border-radius: 9px;
  background: #fff3f3;

  @media (max-width: 760px) {
    grid-template-columns: 40px 1fr;

    & > div:last-child {
      grid-column: 1 / -1;
    }
  }
`;

const DeleteWarningIcon = styled.span`
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d94b4b;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
`;

const DeleteWarningContent = styled.div`
  min-width: 0;

  strong, span {
    display: block;
  }

  strong {
    color: #bf3030;
    font-size: 12px;
    font-weight: 800;
  }

  span {
    margin-top: 6px;
    color: #a65e5e;
    font-size: 9px;
    line-height: 1.55;
  }
`;

const DeleteWarningAction = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 9px;
  text-align: right;

  > span {
    color: #a65e5e;
    font-size: 9px;
    line-height: 1.45;
  }

  button {
    width: 108px !important;
    height: 38px !important;
    border-radius: 7px !important;
    background: #cc4545 !important;
    color: #fff !important;
    font-size: 11px !important;
    font-weight: 700 !important;
  }

  button:hover {
    background: #b93636 !important;
  }

  @media (max-width: 760px) {
    align-items: stretch;
    text-align: left;

    button {
      width: 100% !important;
    }
  }
`;
